import { useMemo } from 'react';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { WithApolloContext } from 'modules/Apollo/types';

export const OWNER_SCOPE = Object.freeze({
  All: 'All',
  Personal: 'Personal',
  Clinic: 'Clinic',
});

export type TOwnerScope = (typeof OWNER_SCOPE)[keyof typeof OWNER_SCOPE];

// The API interprets the string "null" to mean belonging to the clinic.
const clinicId = 'null';

/**
 * Hook that generates the correct array of [ID!] to pass to the graphql
 * templates or macros query "owners" argument.
 */
export const useOwnerScope = ({
  scope,
  context,
}: { scope: TOwnerScope } & WithApolloContext): Array<string> => {
  const query = useCurrentUser({ context });

  const meId = query.data?.me?.id || '';

  return useMemo(() => {
    if (scope === OWNER_SCOPE.Personal) return [meId];
    if (scope === OWNER_SCOPE.Clinic) return [clinicId];
    return [meId, clinicId];
  }, [scope, meId]);
};
